import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetIdsHealthcareservicesHcsIdRequestersId } from '@toktokdoctech/tokapi-client'
import { RequesterFormWrapperProps } from './_props'
import CommonLoaderBackdrop from '../Common/CommonLoaderBackdrop'
import RequesterForm from './RequesterForm'
import { useRequesterFormContext } from './utils/requesterFormContext'
import sxs from './_sxs'
import { defaultRppsData } from './utils/_utils'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import { RouterRouteId } from '../../routers/_props'

const RequesterFormWrapper = ({ mode }: RequesterFormWrapperProps) => {
    const { state } = useRequesterFormContext()
    const currentHcs = useCurrentHcs()
    const params = useParams<RouterRouteId>()

    const requesterId = params.id || ''
    const editMode = mode === 'EDITION'

    const { data, isLoading, isError } = useGetIdsHealthcareservicesHcsIdRequestersId(
        currentHcs?.id || '',
        requesterId,
        {
            query: {
                queryKey: ['requester_details', requesterId],
                enabled: editMode && !!currentHcs?.id && !!requesterId,
            },
        },
    )

    return (
        <>
            {editMode && isLoading && (
                <>
                    <CommonLoaderBackdrop open label={state.loaderMessage} />
                    <Box sx={[sxs.requesterForm, { height: '80dvh' }]} />
                </>
            )}
            {!isLoading && !isError && <RequesterForm mode={mode} data={editMode && data ? data : defaultRppsData} />}
        </>
    )
}

export default RequesterFormWrapper
